<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="picker-products"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
      <div
        class="alert alert--error"
        *ngIf="tradeProductsForm.submitted && tradeProductsForm.theForm.invalid"
      >
        <div class="alert__content">
          <i data-icon></i>
          <span *ngIf="isPack === 0"
            >Pack Size, Pack Quantity and Pack Price must be greater than or
            equal to 0.</span
          >
          <span *ngIf="isPack === 1"
            >Quantity and Unit Price must be greater than or equal to 0.</span
          >
        </div>
      </div>
    </div>

    <div class="modal__content__picker">
      <ul class="nav nav-tabs" gk-picker-tabs>
        <li [ngClass]="{ 'active' : availableList }">
          <a (click)="showAvailableList()">Products</a>
        </li>
        <li [ngClass]="{ 'active' : selectedList }">
          <a (click)="showSelectedList()"
            >Selected ({{selectedProducts.length}})</a
          >
        </li>
      </ul>

      <gk-picker-wrapper
        class="container container--row container--np table-list"
      >
        <gk-picker
          class="grid--6 container container--column container--np tw-max-w-[45%]"
          [attr.is-visible]="availableList"
        >
          <header class="toolbar">
            <div class="toolbar__section">
              <gk-product-selector
                (productTypeSelected)="saveTradeProducts()"
                [tradeId]="trade.header.id"
                [tradingTypeId]="trade.header.tradingTypeId"
                [isDisabled]="isTradeProductsFormInvalid()"
                [filterText]="filterText"
              ></gk-product-selector>
              <gk-filter
                [filterList]="productFilterOptions"
                [selectedFilter]="productSelector[0]"
                [(filterText)]="filterText"
                (filterEvent)="filterChanged($event)"
                [hideFilter]="true"
                filterName="productSelector"
                placeholder="{{ 'SEARCH_TEXT' | translate }}"
                data-at="filter"
                cdkFocusInitial
                class="tw-absolute tw-right-[150px]"
              ></gk-filter>
              <gk-product-type-list-filter
                class="filter"
                *ngIf="this.productFilterOptions != null &&
                  this.productFilterOptions?.length > 0
                "
                [productTypeList]="this.productFilterOptions"
                [loadPreferences]="true"
                filterName="productSelector"
                (productTypeFilterApplied)="filterChanged($event)"
                class="tw-absolute tw-right-[0px] tw-top-[1px]"
              ></gk-product-type-list-filter>
            </div>
          </header>

          <div class="table" gk-table-scroll-height>
            <div class="table__section table__section--head">
              <table>
                <tr>
                  <th class="table__row__cell--chevron"></th>
                  <th colspan="3">
                    <div class="u-ellipsis">Name</div>
                  </th>
                  <th>
                    <div class="u-ellipsis">Unit</div>
                  </th>
                  <th>
                    <div class="u-ellipsis u-text-right" title="Price/Unit">
                      Price/Unit
                    </div>
                  </th>
                  <th class="table__row__cell--control"></th>
                </tr>
              </table>
            </div>

            <div
              class="table__section table__section--body"
              [ngClass]="{ 'is-empty' : products.length === 0 }"
            >
              <div class="u-ellipsis muted" *ngIf="products.length === 0">
                No products available for selection, click above to add a new
                product
              </div>
              <table *ngIf="products.length > 0">
                <tr
                  *ngFor="let product of products"
                  gkTableAccessibility
                  [ngClass]="{ 'is-selected' : product.selected }"
                  data-at="unpicked-item"
                >
                  <td class="table__row__cell--chevron">
                    <button
                      *ngIf="productUtil.hasSubSection(product)"
                      (click)="productUtil.expandOrCollapse(product)"
                    >
                      <i
                        [attr.data-icon]="product.isExpanded ? 'caret-down' : 'caret-right'"
                      >
                      </i>
                    </button>
                  </td>
                  <td
                    [ngClass]="{ 'tw-opacity-70' : product.isHidden}"
                    colspan="3"
                    (click)="addProduct(product)"
                  >
                    <div class="field-detail">
                      <div class="field-detail__section">
                        <div class="working-area" data-at="name">
                          {{ productUtil.getFormattedProductDetailName(product)
                          }}
                        </div>
                        <div class="cropping-record">
                          <div class="cropping-record__type" data-at="meta">
                            {{ product.productTypeName }} {{ product.mappNumber
                            }}
                          </div>
                        </div>
                        <gk-tooltip
                          *ngIf="product.isExpanded"
                          class="small"
                          [message]="product.content"
                        />
                      </div>
                    </div>
                  </td>
                  <td
                    [ngClass]="{ 'tw-opacity-70' : product.isHidden}"
                    (click)="addProduct(product)"
                  >
                    <div class="u-ellipsis">{{ product.unitName }}</div>
                  </td>
                  <td
                    [ngClass]="{ 'tw-opacity-70' : product.isHidden}"
                    (click)="addProduct(product)"
                  >
                    <div class="u-ellipsis u-text-right">
                      {{ product.unitPrice | number: '1.3-3' }}
                    </div>
                  </td>
                  <td
                    class="table__row__cell--control"
                    (click)="addProduct(product)"
                    *ngIf="!product.selected"
                  >
                    <gk-icon-button icon="add_circle" size="compact">
                    </gk-icon-button>
                  </td>
                  <td
                    class="table__row__cell--control"
                    *ngIf="product.selected"
                  ></td>
                </tr>
              </table>
            </div>
          </div>
        </gk-picker>

        <gk-picker
          class="grid--6 container container--column container--np"
          [attr.is-visible]="selectedList"
        >
          <header class="toolbar">
            <div class="toolbar__section toolbar__section--subtitle">
              <div class="u-ellipsis">Selected Products</div>
            </div>
            <div class="toolbar__section toolbar__section--right">
              <gk-checkbox-group [isHeader]="true">
                <gk-radio-button
                  name="unitsSelector"
                  [buttons]="radioButtons"
                  [(ngModel)]="isPack"
                  (buttonSelectedEvent)="onChangeUnitType()"
                  dataAt="radio-productContainer"
                ></gk-radio-button>
              </gk-checkbox-group>
            </div>
          </header>

          <gk-edit-trade-products-form
            (saveForm)="saveTradeProducts()"
            [isPack]="isPack"
            [selectedProducts]="selectedProducts"
            (productRemoved)="removeProduct($event)"
          >
          </gk-edit-trade-products-form>
        </gk-picker>
      </gk-picker-wrapper>
    </div>
    <footer class="toolbar modal__content__footer">
      <div class="toolbar__section toolbar__section--right">
        <gk-icon-button
          type="submit"
          btnType="square-fill"
          icon="check"
          size="compact"
          (buttonClick)="tradeProductsForm.save()"
          data-at="button-save"
        >
        </gk-icon-button>
      </div>
    </footer>
  </div>
</div>
